export const dashboardCollectionGuard = 'GET /reports/orders/state';
export const dashboardResourceGuard =
  'GET /reports/orders/state/[a-zA-Z0-9- ]+/details';
